import(/* webpackMode: "eager" */ "/carbonara/apps/webapp/src/app/error.tsx");
